/* Cidney theme - minimal JS */
(function() {
  // FAQ accordion toggles
  document.addEventListener('click', function(e) {
    var header = e.target.closest('[data-cc-faq-q]');
    if (!header) return;
    var item = header.closest('[data-cc-faq-item]');
    if (!item) return;
    var open = item.getAttribute('data-open') === 'true';
    item.setAttribute('data-open', open ? 'false' : 'true');
    var body = item.querySelector('[data-cc-faq-a]');
    if (body) body.style.display = open ? 'none' : 'block';
    var icon = item.querySelector('[data-cc-faq-icon]');
    if (icon) icon.textContent = open ? '+' : '−';
  });

  // Mobile menu toggle
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-cc-mobile-toggle]');
    if (!btn) return;
    var menu = document.querySelector('[data-cc-mobile-menu]');
    if (!menu) return;
    var open = menu.getAttribute('data-open') === 'true';
    menu.setAttribute('data-open', open ? 'false' : 'true');
    menu.style.display = open ? 'none' : 'flex';
  });
})();
